import React from 'react';
import ReactModal from 'react-modal';
import classNames from "classnames";


export type ModalPopupProps = {
	open: boolean;
	title: string;
	size: 'sm' | 'mid' | 'lg' | 'xlg' | 'alert' | 'alert04';
	className?: string;
	onClose?: () => void;
	onAfterOpen?(): void;
	onAfterClose?(): void;
	children?: React.ReactNode;
	onRequestClose?(event: React.MouseEvent | React.KeyboardEvent): void;
};

// ModalPopup.defaultProps = {
// 	open: false,
// 	title: '',
// 	size: 'mid',
// };
function ModalPopup({children, onAfterClose, onAfterOpen, onClose, open = false, size='mid', className, title = '', onRequestClose}: ModalPopupProps) {
	ReactModal.setAppElement('#root');
	const handleClose = () => {
		if (onClose) {
			onClose();
		}
	};

	return (
		<ReactModal
			isOpen={open}
			portalClassName={classNames(`modal-popup`, `size-${size}`, className)}
			onAfterOpen={onAfterOpen} // 모달이 열린 후에 실행될 함수 prop 전달
			onAfterClose={onAfterClose}
			onRequestClose={onRequestClose}
		>
			<div className="modal-popup-header">
				<h1 className="title">{title}</h1>
				<button type="button" className="btn-close" onClick={handleClose}>닫기</button>
			</div>
			<div className="modal-popup-body">{children}</div>
		</ReactModal>
	);
}

export default ModalPopup;
